'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosInformatempty = function IoIosInformatempty(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.1 13.4c0-1 0.6-1.5 1.6-1.5s1.6 0.5 1.6 1.5-0.6 1.6-1.6 1.6-1.6-0.5-1.6-1.6z m3.2 13.5h1.2v0.6h-5v-0.6h1.3v-9.4h-1.3v-0.6h3.8v10z' })
        )
    );
};

exports.default = IoIosInformatempty;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-informatempty.js
// module id = 2422
// module chunks = 0